import Swap from '@/components/ui/swap'
import { formatCurrency } from '@/utils'
import { useLingui } from '@lingui/react/macro'
import { useAtom, useAtomValue } from 'jotai'
import {
  inputBalanceAtom,
  inputPriceAtom,
  stakingInputAtom,
  stTokenAtom,
} from '../atoms'

const LockView = () => {
  const { t } = useLingui()
  const stToken = useAtomValue(stTokenAtom)
  const [input, onChange] = useAtom(stakingInputAtom)
  const inputPrice = useAtomValue(inputPriceAtom)
  const inputBalance = useAtomValue(inputBalanceAtom)

  const onMax = () => {
    onChange(inputBalance)
  }

  if (!stToken) {
    return null
  }

  return (
    <Swap
      from={{
        title: t`You lock:`,
        address: stToken.underlying.address,
        symbol: stToken.underlying.symbol,
        value: input,
        onChange,
        price: `$${formatCurrency(inputPrice)}`,
        balance: `${formatCurrency(Number(inputBalance))}`,
        onMax,
      }}
      to={{
        address: stToken.id,
        symbol: stToken.token.symbol,
        price: `$${formatCurrency(inputPrice)}`,
        value: input,
      }}
    />
  )
}

export default LockView
